<template>

  <div class="PayBill">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:100vh"
      variant="dark"
      id="loader"
    >
    <b-row>
      <b-col cols="12 headerF"><HeaderFixed/></b-col>
      <b-col cols="12 headerM"><HeaderMobile/></b-col>
    </b-row>
      <b-container fluid style="padding-top: 100px;text-align:left;display:block" id="consBillDiv" >

        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">
                  <b-breadcrumb-item href="#home">
                    <router-link to="/Assamese">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        মূখ্যপৃষ্ঠা
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>ৰিচাৰ্জ প্ৰিপেইড মিটাৰ</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <span class="title">প্ৰিপেইড মিটাৰ ৰিচাৰ্জ  কৰক</span>
          </b-col>
        </b-row>
        <hr/>
        <div class="paddingLeft30px">
          <!-- <br>
          <p style="color:red">We are facing some technical issues with our payment gateway. This is expected to be resolved soon. Sorry for the inconvenience.</p> -->

        <b-row>
          <b-col col cols="5" sm="5" md="2" lg="2" style="padding-top: 7px;">
                <span style="font-weight:600" >উপভোক্তা নম্বৰ<span class="text-danger">*</span></span>
          </b-col>
          <b-col col cols="7" sm="7" md="3" lg="3" style="padding-top: 5px;">
              <b-form-input type="text" maxlength="12" id="consNo" value=""  placeholder="প্ৰি-পেইদ্‌ উপভোক্তা নম্বৰ প্ৰৱিষ্ট কৰক" trim required />
          </b-col>
           <b-col col cols="5" sm="5" md="3" lg="2" style="padding-top: 5px;" >
                <img id="captcha" src="#" alt="captcha">
                <a href="#" @click="generateCaptcha()" ><b-icon icon="arrow-clockwise" font-scale="1.8" style="padding-top:7px"></b-icon></a>
              </b-col>
              <b-col col cols="4" sm="4" md="2" lg="2" style="padding-top: 5px;">
                  <b-form-input type="number" id="result" placeholder="উত্তৰ" style="padding-top: 7px;" />
              </b-col> 

          <b-col col cols="3" sm="3" md="2" lg="1" style="padding-top: 5px;text-align:center">
                <b-button id="submitBtn" @click="showDetails()" block pill variant="primary" size="md" class="go" style="width:100%">
                  <b-icon  icon="arrow-right-short" animation="" scale="1.8" >  </b-icon>
                </b-button>

          </b-col>
        </b-row>

    </br>
        <div id="BillDetails" class="billDetails">
          <b-row>
            <b-col cols=12>
                <span class="heading">উপভোক্তাৰ বিৱৰণ</span>
            </b-col>
          </b-row>
          <hr/>

          <b-row class="paddingRow">
          <b-col cols="12" sm="2" md="2" lg="2">
            <span class="label">উপভোক্তাৰ নাম  : </span>
          </b-col>
          <b-col cols="12" sm="2" md="2" lg="2">
            <span class="" id="consName"></span>
          </b-col>
          <b-col cols="12" sm="2" md="2" lg="2">
            <span class="label">ঠিকনা : </span>
          </b-col>
          <b-col cols="12" sm="3" md="3" lg="3">
            <span class="" id="subDiv"></span>
          </b-col>
        </b-row>
        <b-row class="paddingRow">
          <b-col cols="12" sm="2" md="2" lg="2">
            <span class="label">মিটাৰ নম্বৰ : </span>
          </b-col>
          <b-col cols="12" sm="2" md="2" lg="2">
            <span class="" id="meterNo"></span>
          </b-col>
          <!-- <b-col cols="12" sm="2" md="2" lg="2">
            <span class="label">Category : </span>
          </b-col>
          <b-col cols="12" sm="2" md="2" lg="2">
            <span class="" id="category"></span>
          </b-col> -->
        </b-row>
        <b-row class="paddingRow">
          <b-col cols="12" sm="2" md="2" lg="2">
            <span class="label">ৰিচাৰ্জ পৰিমাণ  <span class="text-danger">*</span> :    </span>
          </b-col>
            <b-col cols="12" sm="2" md="2" lg="2">
              <b-form-input type="number" id="amount" placeholder="ৰিচাৰ্জ পৰিমাণ" trim ></b-form-input>
            </b-col>
            <b-col cols="12" sm="2" md="2" lg="2">
            <span class="label">ৰিচাৰ্জ পৰিমাণ নিশ্চিত কৰক <span class="text-danger">*</span> :    </span>
          </b-col>
            <b-col cols="12" sm="2" md="3" lg="3">
              <b-form-input type="number" id="confirmAmount" placeholder="ৰিচাৰ্জ পৰিমাণ নিশ্চিত কৰক" trim ></b-form-input>
            </b-col>
        </b-row>
        <b-row class="paddingRow">
          <b-col cols="12" sm="2" md="2" lg="2">
            <span class="label">ম'বাইল নম্বৰ <span class="text-danger">*</span> :</span>
          </b-col>
          <b-col cols="12" sm="2" md="2" lg="2">
            <b-form-input type="number" id="mobileNo" placeholder="ই-ৰচিদৰ বাবে ম'বাইল নম্বৰ" trim />
          </b-col>
          <b-col cols="12" sm="2" md="2" lg="2">
            <span class="label">ই-মেইল :</span>
          </b-col>
          <b-col cols="12" sm="2" md="3" lg="3">
            <b-form-input type="email" id="emailId" placeholder="ই-ৰচিদৰ বাবে ই-মেইল " trim />
          </b-col>
        </b-row>
      <br>
        <b-row>
              <b-col cols="12"sm="3" md="3" lg="3" offset-sm="4" offfset-md="4" offset-lg="4">

                  <b-button block squared variant="primary" @click="payNow()">
                   <b-icon icon="credit-card" animation=""  >  </b-icon> PAY NOW
                 </b-button>

              </b-col>
            </b-row>
          </div>
      </div>

  </b-container>
  <b-container fluid style="padding-top: 100px;text-align:left;display:none" id="billdeskRequestDiv">

    <br><br>
  <b-row id="spinner" style="display:block">
    <b-col cols=12 align="center">
      <h3 class="">Processing Payment Request...</h3>
      <br><br>
        <b-spinner style="width: 10rem; height: 10rem;" variant="primary" label="Spinning"></b-spinner>
      <br><br><br>
       <h5 style="color:red">Please do not press back or refresh button</h5>
    </b-col>
  </b-row>
  <b-row id="errorDiv" style="display:none">
    <b-col cols=12 align="center">
      <h2 style="color:red" id="errorMsg"></h2>
      <br><br>
      <b-button onclick="window.location.reload();">Go Back</b-button>
    </b-col>
  </b-row>
</b-container>
<br><br>
</b-overlay>

<form :action = "reqUrl" method="post" id="pgrequest" hidden>
    <input type="" name="msg" :value = "messageToSend" hidden >
    <input type="submit" id="submit" value="submit" hidden >
</form>

    <b-modal id="model" centered  scrollable title="ALERT !" :static="true" hide-footer>
      <span class="data" id="msg"> DEMO </span>
      <br><br>
        <b-button  style="width:8rem" variant="outline-primary" @click="closeModal()">OK</b-button>
    </b-modal>

    <b-modal id="holdingModal" centered  scrollable title="ATTENTION !" :static="true" hide-footer>
      <div  style="background-color: #fffec49e;padding:1rem">
      <span class=""  style="color:#e64a19;font-size:1.05rem;font-weight:600"> 
        প্ৰিয় গ্ৰাহক, আপোনাক অনুৰোধ কৰা হৈছে যে আপোনাৰ হোল্ডিং নম্বৰটো এপিডিচিএল গ্ৰাহক নম্বৰৰ সৈতে সংযোগ কৰক।
        <br>ইতিমধ্যে আপডেট কৰা হ'লে আওকাণ কৰক। </span>
      <br><br>
      <a href="HoldingNoUpdate" class="blink_me">হোল্ডিং নম্বৰ লিংক কৰিবলৈ ইয়াত ক্লিক কৰক</a>
      <br><br>
         <b-button  style="" variant="outline-primary" @click="closeModalH()">
           SKIP AND PROCEED TO PAY
         </b-button>
       </div>
    </b-modal>
  </div>

</template>


<script>

import HeaderFixed from '@/components/AS_HeaderFixed.vue'
import HeaderMobile from '@/components/AS_HeaderMobile.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)
var consNo="";
var sdCode = "";
var consName="";
var vendor="";
var isSmart = "";

export default {
  name: 'PayBill',
  components: {

    'HeaderFixed' : HeaderFixed,
    'HeaderMobile' : HeaderMobile
    //MarqueeText

  },
  computed: {

  },
  data() {
    return {
      show: false,
      message : [
        "",
        "এই উপভোক্তা নম্বৰৰ বাবে কোনো উপভোক্তা পোৱা নগ'ল",
        "এই উপভোক্তা নম্বৰৰ বাবে কোনো বাকী থকা বিল পোৱা নগ'ল",
        "এই উপভোক্তা নম্বৰ অৱৰোধ কৰা হৈছে",
        "পৰিশোধৰ বাবে কোনো বিল পোৱা নগ'ল",
        "",
        "চাৰ্ভাৰ ব্যস্ত! অনুগ্ৰহ কৰি কিছু সময়ৰ পিছত পুনৰ চেষ্টা কৰক",
        "লেনদেন ইতিমধ্যে চলি আছে",
        "বিলডেস্কৰ সৈতে পৰিশোধ অনুৰোধ আৰম্ভ কৰাত ত্ৰুটি"
      ],
      reqUrl : "",
      messageToSend : "",

    }
  },

  methods: {
    generateCaptcha()
    {
      axios.post(this.$urlCommon+"/api/web/getCaptcha").then(function(response) {
                //console.log(response.data);
                document.getElementById("captcha").src= "data:image/png;base64,"+response.data;

    })
    },
    verifyCaptcha()
    {
      var parent = this;
      consNo = document.getElementById("consNo").value;
       if ((consNo.toString().length!=12))
           {
             this.$bvToast.toast('১২ টা অংকৰ উপভোক্তা নম্বৰ প্ৰবিষ্ট কৰক  !', {
               title: `Alert`,
               variant: 'danger',
               solid: true
             })
             return;
           }
      var result = document.getElementById("result").value;
      if ((result==""))
           {
             this.$bvToast.toast('কেপচা প্ৰবিষ্ট কৰক!', {
               title: `Alert`,
               variant: 'danger',
               solid: true
             })
             return;
           }

      axios.post(this.$urlCommon+'/api/web/verifyCaptcha?result='+result)
           .then((response) => {
            console.log(response.data);
            if(response.data=="success")
            {
              console.log("Captcha verified");
              parent.showDetails();
            }
            else{
              parent.$bvToast.toast('ভুল কেপচা! অনুগ্ৰহ কৰি পুনৰ চেষ্টা কৰক', {
                   title: `Alert`,
                   variant: 'danger',
                   solid: true
                 });
              return;
            }
           })

    },
    showDetails() {
    consNo = document.getElementById("consNo").value;
    document.getElementById("mobileNo").value="";
    document.getElementById("emailId").value="";
    document.getElementById("amount").value="";
    document.getElementById("confirmAmount").value="";
    if (consNo.toString().length!=12)
        {
          this.$bvToast.toast('১২ টা অংকৰ উপভোক্তা নম্বৰ প্ৰবিষ্ট কৰক !', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          })
          return;
        }

        var result = document.getElementById("result").value;
      if ((result==""))
           {
             this.$bvToast.toast('কেপচা প্ৰবিষ্ট কৰক!', {
               title: `Alert`,
               variant: 'danger',
               solid: true
             })
             return;
           }
    const sdList=["001","002","003","004","005","006","009","010","011","013","014","015","016","017","023","025","030","093","094","122","123","124","147","148","151","170","171","173","207","208","209"];
    //const sdList=["001","002","003","004","005","006","009","010","011","013","014","015","016","017","023","025","030"];
   
      var sdCode=consNo.substring(0,3);
      console.log("sdCode:::"+sdCode);
      var isGmcCons = sdList.includes(sdCode);
      console.log("isGmcCons:::"+isGmcCons)

      var fetchHolding="";
      if(isGmcCons){
        fetchHolding ="y";
        }
        else{
          fetchHolding ="n";
        }
  
           var parent =this;
          this.show= true;
          axios.post(this.$urlCommon+ '/api/web/prepaidRecharge?consNo='+consNo+'&result='+result+'&fetchHolding='+fetchHolding)
         // axios.post('https://www.apdcl.org/website/api/web/prepaidRecharge?consNo='+consNo)
          .then((response) => {
            //console.log(response.data);
            parent.show= false;
            var data=response.data.prepaidConsDetails;
            var msg=response.data.message;

            if(msg=="Valid") {
              var holdingData = response.data.holdingData;
              if(isGmcCons && holdingData == "Consumer Not Found")
              {
                
                    document.getElementById("BillDetails").classList.remove("showBillDetails");
                    parent.$bvModal.show("holdingModal");
               
               
              }
              sdCode = data.sdCode;
              consName = data.consumerName;
              vendor = data.vendorName;
              isSmart = data.isSmart;
              document.getElementById("consName").innerHTML=data.consumerName;
              document.getElementById("subDiv").innerHTML=data.address;
              document.getElementById("meterNo").innerHTML=data.meterNo;
              // document.getElementById("category").innerHTML=data.categoryName;
             
              document.getElementById("BillDetails").classList.add("showBillDetails");
            }
            else if(msg=="captcha_incorrect")
            {
              parent.$bvToast.toast('ভুল কেপচা! অনুগ্ৰহ কৰি পুনৰ চেষ্টা কৰক', {
                   title: `Alert`,
                   variant: 'danger',
                   solid: true
                 });
              document.getElementById("BillDetails").classList.remove("showBillDetails");
            }
            else
            {              
              parent.$bvModal.show("model");
              if (data.errorcode == "No connection to secure service.")
                document.getElementById("msg").innerHTML="Error Connecting to Prepaid Meter Server";
              else if(data.errorcode.length > 1)
                document.getElementById("msg").innerHTML=data.errorcode;
              else
                document.getElementById("msg").innerHTML=msg;

                document.getElementById("BillDetails").classList.remove("showBillDetails");
            }
            parent.generateCaptcha();
      })
      .catch((e) => {
        parent.show= false;
        parent.$bvModal.show('model');
        document.getElementById("msg").innerHTML="দুঃখিত, অনুগ্ৰহ কৰি পিছত পুনৰ চেষ্টা কৰক";
        console.log("Caught :::::::::::::::", e.message);
        parent.generateCaptcha();
    })
  
},

    payNow()
    {
      var mobileNo = document.getElementById("mobileNo").value;
      var emailId = document.getElementById("emailId").value;
      var amountPaid = document.getElementById("amount").value;
      var confirmAmount = document.getElementById("confirmAmount").value;
      if (emailId=="")
      {
        emailId="NA";
      }
    var dataToSend = {
      "consNo": consNo,
      "amountPaid": amountPaid,
      "mobileNo":mobileNo,
      "email":emailId,
      "consName":consName,
      "vendor":vendor
    }
 console.log(dataToSend);
 if (amountPaid != confirmAmount)
          {
            this.$bvToast.toast('একে পৰিমাণ প্ৰবিষ্ট কৰক  !', {
              title: `Alert`,
              variant: 'danger',
              solid: true
            })
            document.getElementById("confirmAmount").focus();
            return;
          }

      if ( (amountPaid<100 || amountPaid>5000) && isSmart!="Y" )
          {
            this.$bvToast.toast('১০০.০০ টকাৰ পৰা ৫০০০.০০ টকাৰ ভিতৰত পৰিমাণ প্ৰবিষ্ট কৰক  !', {
              title: `Alert`,
              variant: 'danger',
              solid: true
            })
            document.getElementById("amount").focus();
            return;
          }
          if ((parseInt(amountPaid)%100)!= 0 )
              {
                this.$bvToast.toast('পৰিমাণ ১০০.০০ ৰ গুণিতক প্ৰবিষ্ট কৰক !', {
                  title: `Alert`,
                  variant: 'danger',
                  solid: true
                })
                document.getElementById("amount").focus();
                return;
              }
      if (mobileNo.length!=10)
          {
            this.$bvToast.toast('১0 টা অংকৰ মবাইল নম্বৰ প্ৰবিষ্ট কৰক !', {
              title: `Alert`,
              variant: 'danger',
              solid: true
            })
            document.getElementById("mobileNo").focus();
            return;
          }


    // axios.post( "https://www.apdcl.org/restapi/RestAPI/website/consDetailsUpdateFromEasyPay?consNo="+consNo+"&mobNo="+mobileNo)
    // .then((response) => {
    //   //console.log(response.data);
    // })
    document.getElementById("consBillDiv").style.display="none";
    document.getElementById("billdeskRequestDiv").style.display="block";
    var parent=this;

    //axios.post( this.$urlCommon+'/api/onlineprepaid/pgrequest?consNo='+consNo+'&subDiv='+sdCode+"&amountPaid="+amountPaid+"&mobileNo="+mobileNo+"&email="+emailId)
    axios.post( this.$urlCommon+'/api/v2/onlineprepaid/pgrequest',dataToSend)
    .then((response) => {
      console.log(response.data);
      var data=response.data;
      var status=response.data.message;

      if(status=="00") {
        parent.reqUrl = data.action;
        parent.messageToSend= data.msg;
        setTimeout(function(){ document.getElementById("submit").click(); }, 2000);
      }
      else
      {
        document.getElementById('spinner').style.display = 'none';
        document.getElementById('errorDiv').style.display = 'block';
        document.getElementById('errorMsg').innerHTML = parent.message[parseInt(status)];
        this.$bvModal.show("model");
        document.getElementById("msg").innerHTML=parent.message[parseInt(status)];
      }
    })
    .catch((e) => {
    console.log("Caught", e);
    this.show= false;
    this.$bvModal.show("model");
    document.getElementById("msg").innerHTML=e;
    document.getElementById("BillDetails").classList.remove("showBillDetails");
  })

    },
    closeModal(){
      this.$bvModal.hide('model')
    },
    closeModalH(){
      this.$bvModal.hide('holdingModal')
    }
  },
  mounted()
  {
    axios.post(this.$urlCommon+"/api/web/getCaptcha").then(function(response) {
               
                document.getElementById("captcha").src= "data:image/png;base64,"+response.data;

    })
  }
}


</script>

<style scoped="true">
.blink_me {
  animation: blinker 1s linear infinite;
  font-weight:600;
}

@keyframes blinker {
  50% {
    /* color:red; */
     opacity: 0;
  }
}
td{
  padding:0.7rem;
}
.label{
font-weight: 600;
}
.data{
  font-weight: 600;
  color: #ff5722         ;
  font-size: 1.5rem;
}
.billDetails
{
   visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;
  box-shadow: 2px 2px 10px 2px #bdbdbd;
    padding: 1rem;
}
.showBillDetails
{

  visibility: visible;
 opacity: 1;
}
hr {
   margin-top: 5px;
   margin-bottom: 5px;
  }
.go:focus{
  box-shadow: none;
}
.headerF{
  display: block;
}
.headerM{
  display: none;
}
.paddingRow{
  padding:0.7rem;
}
.paddingLeft30px{
  padding-left: 30px;
}
@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .paddingLeft30px{
      padding-left: 0px;
    }
}
</style>
